import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  height: 1400px;
`;

const Content = styled.div`
  min-width: 1400px;
  width: 1400px;
  height: 1400px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px;
`;

const ContentDiv = styled.div`
  margin-top: 50px;
`;

const Logo = styled.img`
  width: 206px;
  height: 67.43px;
  margin-top: 25px;
`;

const FooterContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  height: 320px;
  background-color: white;
  border-top: 1px solid #cfcfcf;
`;

const FooterContent = styled.div`
  min-width: 1400px;
  width: 1400px;
  height: 320px;
  position: relative;
`;

const Company = styled.div`
  color: white;
  font-size: 16px;
  font-weight: 600;
  position: absolute;
  top: 47px;
  color: #5a5a5a;
`;

const CompanyLine = styled.div`
  width: 1400px;
  height: 1px;
  position: absolute;
  top: 87px;
  border: 1px solid #cfcfcf;
`;

const CompanyDes = styled.div`
  top: 108px;
  position: absolute;
  font-size: 16px;
  line-height: 30px;
  color: #888888;
`;

const CompanyPolicy = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #888888;
  position: absolute;
  top: 183px;
  cursor: pointer;
`;

const MobileContaienr = styled.div`
  width: 100%;
  min-width: 360px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const MobileContent = styled.div`
  width: 360px;
  min-width: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const MobileLogo = styled.img`
  width: 170px;
  margin-top: 50px;
`;

const MFooterContainer = styled.div`
  display: flex;
  justify-content: center;
  max-width: 550px;
  width: 100%;
  height: 410px;
  min-width: 360px;
  background-color: white;
  border-top: 1px solid #cfcfcf;
`;

const MFooterContent = styled.div`
  width: 360px;
  min-width: 360px;
  height: 410px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
`;

const MCompany = styled.div`
  position: absolute;
  left: 0px;
  top: 40px;
  color: #5a5a5a;
  font-weight: 600;
`;

const MCompanyLine = styled.div`
  width: 360px;
  height: 1px;
  position: absolute;
  top: 78px;
  border: 1px solid #cfcfcf;
`;

const MCompanyDes = styled.div`
  position: absolute;
  top: 98px;
  line-height: 32px;
  color: #888888;
`;

const MCompanyPolicy = styled.div`
  position: absolute;
  top: 350px;
  left: 0;
  font-weight: 600;
  color: #888888;
  cursor: pointer;
`;

export function Pc({ children }) {
  const isPc = useMediaQuery({
    query: "(min-width: 551px)",
  });

  return <>{isPc && children}</>;
}

export function Mobile({ children }) {
  const isMobile = useMediaQuery({
    query: "(max-width: 550px)",
  });

  return <>{isMobile && children}</>;
}

const Policy = () => {
  const navigate = useNavigate();

  return (
    <>
      <Pc>
        <Container>
          <Content>
            <Logo src="/img/logo.png" />
            <ContentDiv>
              <span style={{ fontSize: 34, fontWeight: 600 }}>
                월리 서비스 개인정보 처리방침
              </span>
              <br /> <br /> <br />{" "}
              <span style={{ fontWeight: 600 }}>제1조 총칙 </span>
              <br />
              <br />
              1. 목적: 본 방침은 월리(이하 "회사")가 제공하는 반려동물 돌봄
              서비스(이하 "서비스")를 이용하는 회원의 개인정보를 보호하고,
              개인정보와 관련된 회원의 권리와 의무를 명확히 규정하는 것을
              목적으로 합니다. <br />
              2. 범위: 본 방침은 서비스를 이용하는 모든 회원에게 적용됩니다.{" "}
              <br />
              <br /> <br />{" "}
              <span style={{ fontWeight: 600 }}>
                제2조 수집하는 개인정보 항목
              </span>{" "}
              <br />
              <br />
              1. 회원가입 시: 가입 방법에 따라 이메일 또는 휴대폰 번호,
              닉네임, 집 주소, 프로필 사진. <br />
              2. 서비스 이용 시: 반려동물의 견종 또는 묘종, 이름, 나이, 성별,
              무게, 중성화 여부, 동물병원, 성향, 예방접종 여부, 기생충 예방 접종
              여부, 사회성 및 기타 참고사항. <br />
              3. 월리로 활동 시: 본인인증 식별정보, 실명, 만 나이, 성별,
              휴대폰 번호, 내/외국인 정보, 통신사 정보. <br /> <br />
              <br />
              <span style={{ fontWeight: 600 }}>
                제3조 개인정보의 수집 및 이용 목적
              </span>
              <br /> <br />
              1. 회원관리: 회원가입 의사 확인, 회원제 서비스 제공, 본인 확인,
              가입 및 탈퇴 의사 확인. <br />
              2. 서비스 제공: 맞춤형 반려동물 돌봄 서비스 제공, 예약 내역 관리,
              LIVE 돌봄 일지 제공. <br />
              3. 고객 지원: 문의 및 불만 처리, 공지사항 전달. <br />
              4. 마케팅 및 광고: 신규 서비스 개발 및 맞춤형 서비스 제공, 이벤트
              정보 및 참여기회 제공. <br /> <br />
              <br />
              <span style={{ fontWeight: 600 }}>
                제4조 개인정보의 보유 및 이용기간
              </span>{" "}
              <br />
              <br />
              1. 보유 기간: 회원 탈퇴 시까지. <br />
              2. 보유 목적: 서비스 제공 및 법령에 따른 보관 의무 준수. <br />{" "}
              <br />
              <br />
              <span style={{ fontWeight: 600 }}>
                제5조 개인정보의 제3자 제공
              </span>{" "}
              <br />
              <br />
              1. 회사는 원칙적으로 회원의 개인정보를 제3자에게 제공하지
              않습니다. 다만, 다음의 경우에는 예외로 합니다. <br />
              - 회원이 사전에 동의한 경우 <br />- 법령에 의거하거나, 법령에 따른
              절차와 방법에 따라 수사기관의 요구가 있는 경우 <br /> <br />
              <br />{" "}
              <span style={{ fontWeight: 600 }}>제6조 개인정보의 파기</span>
              <br />
              <br />
              1. 파기 절차: 수집 및 이용 목적 달성 후 내부 방침 및 관련 법령에
              따라 일정 기간 저장된 후 파기됩니다. <br />
              2. 파기 방법: 전자적 파일 형태의 정보는 기록을 재생할 수 없는
              기술적 방법을 사용하여 삭제하며, 종이 문서에 기록된 개인정보는
              분쇄기로 분쇄하거나 소각하여 파기합니다. <br />
              <br /> <br />{" "}
              <span style={{ fontWeight: 600 }}>
                {" "}
                제7조 회원의 권리와 그 행사 방법
              </span>{" "}
              <br />
              <br />
              1. 회원은 언제든지 자신의 개인정보를 조회하거나 수정할 수 있으며,
              가입 해지를 요청할 수 있습니다. <br />
              2. 개인정보 조회, 수정 및 가입 해지를 위해서는 ‘회원정보 수정’ 및
              ‘회원탈퇴’ 기능을 이용하거나 고객센터를 통해 요청할 수 있습니다.{" "}
              <br /> <br />
              <br />
              <span style={{ fontWeight: 600 }}>
                제8조 개인정보 보호책임자
              </span>{" "}
              <br /> <br />
              1. 책임자: 이승철(대표) <br />
              2. 연락처: 010-6290-2786 <br />
              3. 개인정보 보호 관련 문의, 불만처리 및 피해구제 등을 위해
              개인정보 보호책임자에게 연락할 수 있습니다. <br /> <br />
            </ContentDiv>
          </Content>
        </Container>
        <FooterContainer>
          <FooterContent>
            <Company>(주)월리</Company>
            <CompanyLine />
            <CompanyDes>
              부산광역시 기장군 기장읍 기장대로 82-8 <br />
              사업자 등록번호: 323-88-03325 | 대표: 이승철 | 통신판매신고번호:
              2025-부산기장-0252 | 대표번호: 010-6290-2786 | 문의메일:
              admin@wallykorea.com
            </CompanyDes>
            <CompanyPolicy onClick={() => navigate("#")}>
              개인정보처리방침
            </CompanyPolicy>
          </FooterContent>
        </FooterContainer>
      </Pc>
      <Mobile>
        <MobileContaienr>
          <MobileContent>
            <MobileLogo src="/img/logo.png" />
            <ContentDiv style={{ marginBottom: 50 }}>
              <span style={{ fontSize: 28, fontWeight: 600 }}>
                월리 서비스 개인정보 처리방침
              </span>
              <br /> <br /> <br />{" "}
              <span style={{ fontWeight: 600 }}>제1조 총칙 </span>
              <br />
              <br />
              1. 목적: 본 방침은 월리(이하 "회사")가 제공하는 반려동물 돌봄
              서비스(이하 "서비스")를 이용하는 회원의 개인정보를 보호하고,
              개인정보와 관련된 회원의 권리와 의무를 명확히 규정하는 것을
              목적으로 합니다. <br />
              2. 범위: 본 방침은 서비스를 이용하는 모든 회원에게 적용됩니다.{" "}
              <br />
              <br /> <br />{" "}
              <span style={{ fontWeight: 600 }}>
                제2조 수집하는 개인정보 항목
              </span>{" "}
              <br />
              <br />
              1. 회원가입 시: 가입 방법에 따라 이메일 또는 휴대폰 번호,
              닉네임, 집 주소, 프로필 사진. <br />
              2. 서비스 이용 시: 반려동물의 견종 또는 묘종, 이름, 나이, 성별,
              무게, 중성화 여부, 동물병원, 성향, 예방접종 여부, 기생충 예방 접종
              여부, 사회성 및 기타 참고사항. <br />
              3. 월리로 활동 시: 본인인증 식별정보, 실명, 만 나이, 성별,
              휴대폰 번호, 내/외국인 정보, 통신사 정보. <br /> <br />
              <br />
              <span style={{ fontWeight: 600 }}>
                제3조 개인정보의 수집 및 이용 목적
              </span>
              <br /> <br />
              1. 회원관리: 회원가입 의사 확인, 회원제 서비스 제공, 본인 확인,
              가입 및 탈퇴 의사 확인. <br />
              2. 서비스 제공: 맞춤형 반려동물 돌봄 서비스 제공, 예약 내역 관리,
              LIVE 돌봄 일지 제공. <br />
              3. 고객 지원: 문의 및 불만 처리, 공지사항 전달. <br />
              4. 마케팅 및 광고: 신규 서비스 개발 및 맞춤형 서비스 제공, 이벤트
              정보 및 참여기회 제공. <br /> <br />
              <br />
              <span style={{ fontWeight: 600 }}>
                제4조 개인정보의 보유 및 이용기간
              </span>{" "}
              <br />
              <br />
              1. 보유 기간: 회원 탈퇴 시까지. <br />
              2. 보유 목적: 서비스 제공 및 법령에 따른 보관 의무 준수. <br />{" "}
              <br />
              <br />
              <span style={{ fontWeight: 600 }}>
                제5조 개인정보의 제3자 제공
              </span>{" "}
              <br />
              <br />
              1. 회사는 원칙적으로 회원의 개인정보를 제3자에게 제공하지
              않습니다. 다만, 다음의 경우에는 예외로 합니다. <br />
              - 회원이 사전에 동의한 경우 <br />- 법령에 의거하거나, 법령에 따른
              절차와 방법에 따라 수사기관의 요구가 있는 경우 <br /> <br />
              <br />{" "}
              <span style={{ fontWeight: 600 }}>제6조 개인정보의 파기</span>
              <br />
              <br />
              1. 파기 절차: 수집 및 이용 목적 달성 후 내부 방침 및 관련 법령에
              따라 일정 기간 저장된 후 파기됩니다. <br />
              2. 파기 방법: 전자적 파일 형태의 정보는 기록을 재생할 수 없는
              기술적 방법을 사용하여 삭제하며, 종이 문서에 기록된 개인정보는
              분쇄기로 분쇄하거나 소각하여 파기합니다. <br />
              <br /> <br />{" "}
              <span style={{ fontWeight: 600 }}>
                {" "}
                제7조 회원의 권리와 그 행사 방법
              </span>{" "}
              <br />
              <br />
              1. 회원은 언제든지 자신의 개인정보를 조회하거나 수정할 수 있으며,
              가입 해지를 요청할 수 있습니다. <br />
              2. 개인정보 조회, 수정 및 가입 해지를 위해서는 ‘회원정보 수정’ 및
              ‘회원탈퇴’ 기능을 이용하거나 고객센터를 통해 요청할 수 있습니다.{" "}
              <br /> <br />
              <br />
              <span style={{ fontWeight: 600 }}>
                제8조 개인정보 보호책임자
              </span>{" "}
              <br /> <br />
              1. 책임자: 이승철(대표) <br />
              2. 연락처: 010-6290-2786 <br />
              3. 개인정보 보호 관련 문의, 불만처리 및 피해구제 등을 위해
              개인정보 보호책임자에게 연락할 수 있습니다. <br /> <br />
            </ContentDiv>
          </MobileContent>
        </MobileContaienr>
        <MFooterContainer>
          <MFooterContent>
            <MCompany>(주)월리</MCompany>
            <MCompanyLine />
            <MCompanyDes>
              부산광역시 기장군 기장읍 기장대로 82-8
              <br />
              <br />
              사업자 등록번호: 323-88-03325 | 대표: 이승철
              <br />
              통신판매신고번호: 2025-부산기장-0252
              <br />
              대표번호: 010-6290-2786
              <br />
              문의메일: admin@wallykorea.com
            </MCompanyDes>
            <MCompanyPolicy onClick={() => navigate("#")}>
              개인정보처리방침
            </MCompanyPolicy>
          </MFooterContent>
        </MFooterContainer>
      </Mobile>
    </>
  );
};

export default Policy;
